// removed by extract-text-webpack-plugin
module.exports = {"hidden":"DYPpS","visuallyhidden":"_1HORC","hide-text":"_2Z6Ei","center":"_109Ul","noprint":"_2LzHR","date":"_3tgva"};


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-label/styles/Label.scss
 ** module id = 946
 ** module chunks = 1
 **/